module.exports = __webpack_public_path__ + "img/green.0f26097c.svg";